module.exports = {
  stores: [
    {
      // The custom domain added to the Shopify dashboard
      customDomain: 'secure.stoxenergy.com',
      // The subdomain of myshopify.com.
      subdomain: 'stoxsocks',
      storefrontAccessToken: '2691daa01639d53f26b3d3c29f276dca',
      // Define if this store should be used as the default store.
      //
      // If this is undefined or false in all stores, the first store will be
      // used as the default store.
      //
      // If this is true in more than one stores, the first store that sets this
      // to be true will be used as the default store.
      default: true,
      // Define properties that will be accessed later. E.g.,
      // currency: '$',
    },
    {
      subdomain: 'stox-usa',
      customDomain: 'usa.stoxenergy.com',
      storefrontAccessToken: 'baa3854d4d2eb1191d9791a2d3358fe8',
      default: false,
    },
    {
      subdomain: 'stox-uk',
      customDomain: 'uk.stoxenergy.com',
      storefrontAccessToken: 'd45ad533a402a5cc35727e90f07d9bb9',
      default: false,
    },
  ],
}
